import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { DealClosingReasonService } from 'src/app/services/deal-closing-reason.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';

@Component({
  selector: 'calsoft-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent  implements   OnInit, OnDestroy{


  url = '';
  sanitizedUrl = '';


   reason: string = "";
  submitted = false;
  confirmForm: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
     private dealClosingReasonService: DealClosingReasonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
     private dynamicFormLabelService: DynamicFormLabelService, private router: Router,
     private fb: UntypedFormBuilder
  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });}
  ngOnInit(): void {
    
    this.confirmForm = this.fb.group({
      reason: [this.reason, this.data.isLost ? [Validators.required] : []],
      description: [this.data.description, [Validators.required]]
    });

    console.log("data" , this.data);
    
   
    this.dealClosingReasonService.getAllLeadStatusDropDown(9).subscribe(
        res => {

          this.dealsCloseReasonList = res;


          this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonList;
        },
        error => {
        }
      )
      this.DealsCloseReasonYFilter();
      this.getDealsCloseReasonList();

  }

   confirm() {
    this.submitted = true;
    if (this.confirmForm.valid) {
      this.dialogRef.close({ 
        confirmed: true, 
        reason: this.confirmForm.value.reason, 
        description: this.confirmForm.value.description, 
        leadId: this.data.leadId, 
        stageName: this.data.newStatus 
      });
    } else {
      this.confirmForm.markAllAsTouched();
    }
  }

  close() {
    this.dialogRef.close({ confirmed: false });
  }

   //deals close Reason

  dealsCloseReasonList: any;
  dealsCloseReasonTypeList: any;
  filteredDealsCloseReasonTypeList: any;

  public dealsCloseReasonFilterControl: UntypedFormControl = new UntypedFormControl();

  getDealsCloseReasonList() {

    this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonTypeList;
  }

  DealsCloseReasonYFilter() {
    this.dealsCloseReasonFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.DealsCloseReasonFilter();
      });
  }


  protected DealsCloseReasonFilter() {
    if (!this.dealsCloseReasonTypeList) {
      return;
    }
    // get the search keyword
    let search = this.dealsCloseReasonFilterControl.value;
    if (!search) {
      this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredDealsCloseReasonTypeList = this.dealsCloseReasonTypeList.filter(reason => reason['statusName']
      .toLowerCase().indexOf(search) > -1)
  }

    getcreateDynamicForm(formGroupId) {

    this.getFormArray(formGroupId)

  }

   init: boolean = false;


  regConfig: any[] = [];

  newType: any = 1;
   getFormArray(formGroupId) {
    this.init = false;
    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;
        this.init = true;
        this.newType = 2;
      }


    });
  }
  protected _onDestroy = new Subject<void>();
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

   createDynamicForm(event, formGroupId) {
    if (event.isUserInput != false) {

      this.getcreateDynamicForm(formGroupId)
    }

  }






  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
